// @flow

import * as React from 'react';
import { Icon } from '@ta/styleguide.icon';
import classNames from '@ta/common.classnames';
import { globalize, localize } from '@ta/common.i18n';

import styles from './PhotoCount.less';

type Props = {|
  /** Total number of photos */
  totalCount: number,
|};

const PhotoCount = ({ totalCount }: Props) => (
  <div className={styles.seeAll}>
    <Icon name="camera" />
    &nbsp;
    <span className={classNames('is-shown-at-tablet', styles.seeAllText)}>
      {localize('all_photos_parens', {
        nCount: globalize.formatNumber('integer', totalCount),
      }) /* All Photos (nCount) */}
    </span>
    <span className="is-hidden-tablet">{globalize.formatNumber('integer', totalCount)}</span>
  </div>
);

export default PhotoCount;
